module.exports = __webpack_public_path__ + "static/MAI_DataReports_03-32b14d10c650cdec46e348dc890d0673.png";